import { z } from 'zod';
import { SessionTagIdSchema } from '../dto/SessionTags.js';
export const InterviewSessionCreatedEventSchema = z.object({
    subject: z.literal('interviews-data.session.created'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
    }),
});
export const InterviewSessionTagAttachedEventSchema = z.object({
    subject: z.literal('interviews-data.session.tag-attached'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string().guid(),
        tagId: SessionTagIdSchema,
    }),
});
export const InterviewSessionTagDetachedEventSchema = z.object({
    subject: z.literal('interviews-data.session.tag-detached'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string().guid(),
        tagId: SessionTagIdSchema,
    }),
});
export const InterviewQualityCompletedEventSchema = z.object({
    subject: z.literal('interviews-data.session.quality-completed'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
    }),
});
export const InterviewSessionFinishedEventSchema = z.object({
    subject: z.literal('interviews-data.session.finished'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
        callId: z.string().nullable(),
        conversationProvider: z.string().nullable(),
    }),
});
export const InterviewQualityProcessingRequestedEventSchema = z.object({
    subject: z.literal('interviews-data.session.quality-processing-requested'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
    }),
});
export const PrimaryRecordingCompletedEventSchema = z.object({
    subject: z.literal('interviews-data.session-media.primary-recording-completed'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
        mediaAssetId: z.string(),
        contentType: z.string(),
        sourceProvider: z.string(),
        sourceAssetId: z.string().nullable(),
        durationSeconds: z.number().multipleOf(1).nonnegative().nullable(),
    }),
});
export const InterviewSessionAbandonedEventSchema = z.object({
    subject: z.literal('interviews-data.session.abandoned'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
    }),
});
export const QualityStatusEnum = z.enum(['completed', 'incomplete', 'invalid']);
export const ReturnReasonCategoryEnum = z.enum(['technical_problems', 'did_not_finish']);
export const InterviewQualityEvaluatedEventSchema = z.object({
    subject: z.literal('interviews-data.session.quality-evaluated'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z.object({
        sessionId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
        qualityStatus: QualityStatusEnum,
        returnReasonCategory: ReturnReasonCategoryEnum.optional(),
    }),
});
export const InterviewOutboundUpdatedEventSchema = z.object({
    subject: z.literal('interviews-data.session.outbound-updated'),
    correlationId: z.string(),
    occurredAt: z.string(),
    data: z
        .object({
        sessionId: z.string().guid(),
        projectId: z.string().guid(),
        organizationId: z.string().guid(),
        callAttemptId: z.string().guid(),
    })
        .strict(),
});
//# sourceMappingURL=index.js.map